 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","11":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~a17b1a1c","12":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~a69d551e","13":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~3ce43b72","14":"vendors~Header~about~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~~d2e04549","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_reviews_page~hotels~order_changing_reques~d1dfa4b8","19":"authVendor","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~c2715e70","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","25":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~tinkoff_iframe","26":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","27":"vendors~Cigarette~about~header_app~tinkoff_iframe","28":"vendors~Cigarette~EmptySearch~tinkoff_iframe","29":"vendors~Cigarette~HotelNotice~tinkoff_iframe","30":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","31":"vendors~Header~about~header_app","33":"AuthNew~ClientFormContainer","34":"FiltersPanel","35":"Map~YandexMapsSearch","37":"vendors~AuthNew~ClientFormContainer","38":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptyMap","47":"EmptySearch","48":"ExpensiveHotelsPopup","49":"FiltersPanelMobile","50":"FlightFail","51":"FlightsItem","52":"Header","53":"HeaderAuth","54":"HotelNotice","55":"IosIcon","56":"Map","57":"MountainsContainer","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","92":"sigmaInit","98":"vendors~AboutRoomPopup","99":"vendors~HeaderAuth","100":"vendors~Subscribe","105":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"fa28cbb395ce8fd43edb","11":"d9e36fa8fbe14db9c3ad","12":"102461ec23775dac2274","13":"ac0afeddf724ceec7819","14":"4f4c27571f1b50963bc4","16":"685fea4a34c73bddfb81","18":"3eb0b843176fb46d57d4","19":"6b3168805c65a39b80bf","20":"8490750c1d16efd831e9","23":"8a45ba19e4453a71700f","25":"e7120cc41f37e8424fec","26":"0376469911683d776476","27":"906773ecdb839fa10bcf","28":"de835a8efe01190103fc","29":"ee3aa9b7b0aadc13467b","30":"83c20127d89499bc07e6","31":"c8b22e8ec87209949837","33":"5e70833c3880674451b4","34":"58bce27b565a092ba7d5","35":"9e4c64b558fe7cf7e253","37":"23170558ec9b00bb9ffb","38":"7c2b613b58b8d8c45e9f","40":"73eb2f25885d1bd147d1","41":"92e7280acedb1ac7a1cd","42":"c7b749996e68373d3537","43":"d0f1670cbec3a784ec6f","44":"9e4b24a8f4cfe6c37420","45":"f8aa3dc6f95769f8ff8a","46":"74f76ff397599a458383","47":"2f83138f8974baf7c90f","48":"44571e7eeb51147eee04","49":"c29a20e3608400119913","50":"be80fbe9a30c5e1a9611","51":"fa04c605da5b2dfc698b","52":"52db1ef75a48373728f1","53":"2f51b4201f72c71d974e","54":"bd4eeba8805ce9b59c7d","55":"4acede29268d708b248c","56":"d14da370e98f5dc643a6","57":"7519ef0d9baf19e09b90","58":"4cb00fc1797d619c8d1d","59":"024a3088a6075b5b78c3","60":"6295d4a20c0b588b052f","61":"6c3ceca0203eb5705202","62":"84e7d07b2866ee0749f0","63":"b7189288097669916c23","64":"dae6161bc66914ed7eae","65":"692b87c75f9ca7ac2925","66":"e39cdfbc831947603178","67":"388756e973558f5d760b","68":"febafe014fbeeec91d99","69":"80948b6cbc954fc083cb","92":"081df457fdf315808855","98":"5e9c9c81f848471c5f67","99":"f256d07ce606446a7613","100":"857eb378490f9b3aa9cc","105":"973d904e9d5001e29110"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"33":1,"34":1,"35":1,"42":1,"46":1,"48":1,"50":1,"52":1,"53":1,"56":1,"59":1,"62":1,"67":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","11":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~a17b1a1c","12":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~a69d551e","13":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~3ce43b72","14":"vendors~Header~about~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~~d2e04549","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_reviews_page~hotels~order_changing_reques~d1dfa4b8","19":"authVendor","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~c2715e70","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","25":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~tinkoff_iframe","26":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","27":"vendors~Cigarette~about~header_app~tinkoff_iframe","28":"vendors~Cigarette~EmptySearch~tinkoff_iframe","29":"vendors~Cigarette~HotelNotice~tinkoff_iframe","30":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","31":"vendors~Header~about~header_app","33":"AuthNew~ClientFormContainer","34":"FiltersPanel","35":"Map~YandexMapsSearch","37":"vendors~AuthNew~ClientFormContainer","38":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptyMap","47":"EmptySearch","48":"ExpensiveHotelsPopup","49":"FiltersPanelMobile","50":"FlightFail","51":"FlightsItem","52":"Header","53":"HeaderAuth","54":"HotelNotice","55":"IosIcon","56":"Map","57":"MountainsContainer","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","92":"sigmaInit","98":"vendors~AboutRoomPopup","99":"vendors~HeaderAuth","100":"vendors~Subscribe","105":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"3af713dca33677e9d010","11":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","13":"d41d8cd98f00b204e980","14":"d41d8cd98f00b204e980","16":"d41d8cd98f00b204e980","18":"d41d8cd98f00b204e980","19":"d41d8cd98f00b204e980","20":"d41d8cd98f00b204e980","23":"d41d8cd98f00b204e980","25":"d41d8cd98f00b204e980","26":"d41d8cd98f00b204e980","27":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","29":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","31":"d41d8cd98f00b204e980","33":"b515e6771f5f29d1aa05","34":"1e714c1d5007c3e18c77","35":"2c5fc0397a87051c4a07","37":"d41d8cd98f00b204e980","38":"d41d8cd98f00b204e980","40":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"8b56781ad92a57b73497","43":"d41d8cd98f00b204e980","44":"d41d8cd98f00b204e980","45":"d41d8cd98f00b204e980","46":"117e11e4c2e0dbe53fdc","47":"d41d8cd98f00b204e980","48":"9686519f282e3233d6e6","49":"d41d8cd98f00b204e980","50":"7ee0c6da27c553ef2f7a","51":"d41d8cd98f00b204e980","52":"328d96cdeb8bfc7a0b35","53":"e2dc08d21432f13fd3cc","54":"d41d8cd98f00b204e980","55":"d41d8cd98f00b204e980","56":"8bff1df68e0ec6644902","57":"d41d8cd98f00b204e980","58":"d41d8cd98f00b204e980","59":"a65265f17a8153dfeb55","60":"d41d8cd98f00b204e980","61":"d41d8cd98f00b204e980","62":"9f8ec307f98354a9dce5","63":"d41d8cd98f00b204e980","64":"d41d8cd98f00b204e980","65":"d41d8cd98f00b204e980","66":"d41d8cd98f00b204e980","67":"535eb3978ed66b264428","68":"d47b0f7d31bb554b1a83","69":"e77c69f28f6a05a11385","92":"d41d8cd98f00b204e980","98":"d41d8cd98f00b204e980","99":"d41d8cd98f00b204e980","100":"d41d8cd98f00b204e980","105":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
